import { Alert, Button, IconButton, Snackbar } from '@mui/joy'
import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TbCircleCheck, TbX } from 'react-icons/tb'
import { Link } from 'react-router-dom'

import { isExternalAction, type NotificationAction } from '../../store/notifications/types'
import { SNACKBAR_SX } from './snackbarSx'
import { type NotificationViewProps } from './types'

const ACTION_SX = { fontWeight: 600, whiteSpace: 'nowrap' }

const linkPropsFor = (action: NotificationAction): Record<string, unknown> =>
  isExternalAction(action)
    ? { component: 'a', href: action.href, target: '_blank', rel: 'noopener noreferrer' }
    : { component: Link, to: action.path }

const SuccessSnackbar: FC<NotificationViewProps> = ({ notification, onClose, ...props }) => {
  const { t } = useTranslation()
  const actions = notification.extra?.actions ?? []

  return (
    <Snackbar
      {...props}
      onClose={onClose}
      color="success"
      variant="soft"
      sx={SNACKBAR_SX}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        color="success"
        variant="solid"
        sx={{ width: '100%', flexWrap: 'wrap' }}
        startDecorator={<TbCircleCheck size={24} />}
        invertedColors
        endDecorator={
          <>
            {actions.map((action, index) => (
              <Button
                key={`${index}-${action.label}`}
                {...linkPropsFor(action)}
                variant="plain"
                size="sm"
                sx={ACTION_SX}
              >
                {action.label}
              </Button>
            ))}
            <IconButton
              variant="plain"
              aria-label={t('notifications.close')}
              onClick={(event) => {
                onClose?.(event, 'escapeKeyDown')
              }}
            >
              <TbX size={24} />
            </IconButton>
          </>
        }
      >
        {notification.message}
      </Alert>
    </Snackbar>
  )
}

export default SuccessSnackbar
